export default "__VITE_PUBLIC_ASSET__25371dff__"